// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"78545f1f","126":"f5f4790e","197":"cfc0c04a","280":"320da973","724":"66431aea","745":"1a000502","924":"e3592904"}[chunkId] + ".chunk.js";
};